import { h, Fragment } from 'preact'
import { useContext } from 'preact/compat'
import { Query, Loading } from '../context'
import { Checkbox } from './Checkbox.jsx'
import { FacetGroup } from './FacetGroup.jsx'
import classnames from 'classnames'


export function Facets({ facets, onUpdate }) {

	const loading = useContext(Loading)
	const classes = classnames('search-layout__filters', loading && 'loading')

	return <div class={classes}>
		<FacetList facet={facets.category} onUpdate={onUpdate} />
		<FacetList facet={facets.city} onUpdate={onUpdate} />
		<FacetList facet={facets.region} onUpdate={onUpdate} />
		<FacetBoolean facet={facets.remote} onUpdate={onUpdate} />
		<FacetList facet={facets.employmentType} onUpdate={onUpdate} />
		<FacetList facet={facets.timeType} onUpdate={onUpdate} />
	</div>
}


function FacetBoolean({ facet, onUpdate }) {
	if (!facet) return
	if (facet.type !== 'boolean' || facet?.values?.TRUE?.value === undefined) return

	const query = useContext(Query)

	const onChangeBoolean = (event, checked) => {
		const name = event.currentTarget.name
		if (checked) {
			query.set('lastEdited', name)
			query.set(name, '1')
		} else {
			query.remove(name)
		}
		query.set('page', null)
		onUpdate()
	}

	return <FacetGroup title={facet.name}>
		<Checkbox 
			key={facet.key}
			name={facet.key} 
			value="1" 
			label={`Show ${facet.name.toLowerCase()} roles`}
			count={facet.values.TRUE.count} 
			size="x-small"
			block 
			onChange={onChangeBoolean}
			checked={facet.values.TRUE.selected === true}
		/>
	</FacetGroup>
}


function FacetList({ facet, onUpdate }) {
	if (!facet) return
	if (facet.type !== 'list') return
	const entries = Object.entries(facet.values)
	if (!entries.length) return

	const query = useContext(Query)

	const onChangeList = (event, checked) => {
		const name = event.currentTarget.name
		const value = event.currentTarget.value
		query.set('lastEdited', name)
		if (checked) {
			query.addTo(name, value)
		} else {
			query.removeFrom(name, value)
		}
		query.set('page', null)
		onUpdate()
	}

	return <FacetGroup title={facet.name}>
		{entries.map(([value, facetEntry]) => <>
			<Checkbox 
				key={facet.key}
				name={facet.key} 
				value={value} 
				label={value} 
				count={facetEntry.count} 
				size="x-small"
				block 
				onChange={onChangeList}
				checked={facetEntry.selected === true}
			/>
		</>)}
	</FacetGroup>
}